import { ApiRoutes } from "@/enums/apiRoutes.enum";
import axios from "@/lib/axios";
import {
  NotificationRecord,
  NotificationRecipientRecord,
  CreateNotificationPayload,
} from "@/types/data";

export const notificationService = {
  async getAll(): Promise<NotificationRecord[]> {
    const response = await axios.get(ApiRoutes.NOTIFICATIONS);
    return response.data;
  },

  async getRecipients(
    notificationId: string,
  ): Promise<NotificationRecipientRecord[]> {
    const url = ApiRoutes.NOTIFICATION_RECIPIENTS.replace(
      ":id",
      notificationId,
    );
    const response = await axios.get(url);
    return response.data;
  },

  async sendPush(data: {
    title: string;
    body: string;
    url: string;
    tag: string;
    tokens: string[];
  }) {
    const response = await axios.post(ApiRoutes.SEND_PUSH, data);
    return response.data;
  },
};
